<script setup lang="ts">
import { findHelpApp } from '~/data/apps';
import { sortCategories } from '~/utils/categories';

const emit = defineEmits(['navigate']);

const route = useRoute();
const appId = computed(() => String(route.params.id || ''));
const app = computed(() => findHelpApp(appId.value));

const { data: articles } = await useAsyncData(
	() => `articles-sidebar-${appId.value}`,
	() =>
		queryCollectionNavigation('content', ['title', 'path', 'category'])
			.where('published', '=', true)
			.where('path', 'LIKE', `/${appId.value}/%`),
	{ watch: [appId] },
);

const categories = computed(() => {
	const nav = (articles.value ?? []) as any[];
	const stack = [...nav];
	const set = new Set<string>();

	while (stack.length) {
		const node = stack.pop()!;
		if (node?.category) { set.add(node.category); }
		if (Array.isArray(node?.children)) { stack.push(...node.children); }
	}

	return sortCategories([...set], app.value);
});

const toId = (name: string) => name.replace(/[^a-z0-9]/gi, '-').toLowerCase();
</script>

<template>
	<div class="nav-wrapper">
		<nav class="nav">
			<ul class="nav__list">
				<li class="nav__item" v-for="cat in categories" :key="cat">
					<HmNavLink
						:label="cat"
						:to="`/${app?.id}#${toId(cat)}`"
						active-class=" "
						exact-active-class=" "
						@click="emit('navigate')"
					/>
				</li>
			</ul>
		</nav>
	</div>
</template>
